// Schedule + assignment dates are CALENDAR DATES, not moments in time.
// Canonical storage: UTC-midnight epoch seconds of the chosen YYYY-MM-DD day.
// Reads tolerate legacy non-UTC-midnight epochs by mapping them to whichever
// local-time YYYY-MM-DD contains the moment, so existing data still displays
// on the day the user originally picked.

export function pad2(n) {
  return String(n).padStart(2, '0');
}

export function localDateToYyyyMmDd(date) {
  if (!date) return null;
  if (typeof date.getFullYear !== 'function') return null;
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
}

export function yyyyMmDdToUtcMidnightEpoch(yyyyMmDd) {
  if (!yyyyMmDd || typeof yyyyMmDd !== 'string') return null;
  const m = yyyyMmDd.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return null;
  return Math.floor(Date.UTC(parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10)) / 1000);
}

export function dateToUtcMidnightEpoch(date) {
  return yyyyMmDdToUtcMidnightEpoch(localDateToYyyyMmDd(date));
}

// Decodes the canonical UTC-midnight epoch using **UTC** getters so the result
// is the same calendar day regardless of host timezone (handles users west
// of UTC: a UTC-midnight epoch viewed in PDT is the *previous* day in local
// time, so local-getter logic returns the wrong YYYY-MM-DD).
// The returned Date is constructed at *local* midnight of the UTC day so that
// PrimeVue Calendar (which reads local fields) renders the correct day.
export function epochToLocalDateAtMidnight(epoch) {
  if (epoch == null || isNaN(epoch)) return null;
  const d = new Date(epoch * 1000);
  return new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), 0, 0, 0, 0);
}

export function epochToYyyyMmDd(epoch) {
  if (epoch == null || isNaN(epoch)) return null;
  const d = new Date(epoch * 1000);
  return `${d.getUTCFullYear()}-${pad2(d.getUTCMonth() + 1)}-${pad2(d.getUTCDate())}`;
}

// True if YYYY-MM-DD `dayStr` falls within [startStr, endStr] inclusive,
// using string compare (valid because YYYY-MM-DD is lexicographically ordered).
export function isDayInRange(dayStr, startStr, endStr) {
  if (!dayStr || !startStr || !endStr) return false;
  return dayStr >= startStr && dayStr <= endStr;
}
